document.addEventListener("DOMContentLoaded", function() {
    function buildThresholdList() {
        let thresholds = [];
        let numSteps = 50;
        for (let i=1.0; i<=numSteps; i++) {
            let ratio = i/numSteps;
            thresholds.push(ratio);
        }
        //thresholds.push(0);
        return thresholds;
    }

    const lazyBg = document.querySelectorAll(".release-item__wrapper");

    const lazyBackgroundObserver = new IntersectionObserver (function (entries, observer) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                if(entry.intersectionRatio > 0.75){
                    entry.target.classList.add("inview");
                }
                if(entry.intersectionRatio < 1){
                    entry.target.classList.remove("inview");
                }
            } else {
                entry.target.classList.remove("inview");
            }
        });
    }, {threshold: buildThresholdList()});

    lazyBg.forEach ( function (lazyBackground) {
        lazyBackgroundObserver.observe(lazyBackground);
    });
});

document.addEventListener("turbo:render", function() {
    function buildThresholdList() {
        let thresholds = [];
        let numSteps = 50;
        for (let i=1.0; i<=numSteps; i++) {
            let ratio = i/numSteps;
            thresholds.push(ratio);
        }
        //thresholds.push(0);
        return thresholds;
    }

    const lazyBg = document.querySelectorAll(".release-item__wrapper");

    const lazyBackgroundObserver = new IntersectionObserver (function (entries, observer) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                if(entry.intersectionRatio > 0.75){
                    entry.target.classList.add("inview");
                }
                if(entry.intersectionRatio < 1){
                    entry.target.classList.remove("inview");
                }
            } else {
                entry.target.classList.remove("inview");
            }
        });
    }, {threshold: buildThresholdList()});

    lazyBg.forEach ( function (lazyBackground) {
        lazyBackgroundObserver.observe(lazyBackground);
    });
});